export class AmexCard {
    public static isBrandAmex(card: string): boolean {
        return /^3[47]\d{13}/.test(card) && card.length === 15
    }
}